var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5H6V15H13.5V13.5Z",
    fill: "#767575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4.5C7.5 3.67157 8.17157 3 9 3H19.5C20.3284 3 21 3.67157 21 4.5V15C21 15.8284 20.3284 16.5 19.5 16.5H16.5V19.5C16.5 20.3284 15.8284 21 15 21H4.5C3.67157 21 3 20.3284 3 19.5V9C3 8.17157 3.67157 7.5 4.5 7.5H7.5V4.5ZM9 7.5H15C15.8284 7.5 16.5 8.17157 16.5 9V15H19.5V4.5H9V7.5ZM15 9H4.5V19.5H15V9Z",
    fill: "#767575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapseAll.869b0cb5d64b8c32262ea81385945db5.svg";
export { ForwardRef as ReactComponent };